import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

// Connects to data-controller="documents--status-panel"
//
// Closes the document status panel when the user clicks away from it.
//
// The panel is a Bootstrap .collapse rather than a .dropdown. What that costs
// is dismissal: .dropdown closed itself on an outside click, .collapse never
// does. This restores it, at every width — the panel floats over the page as a
// popup on a phone too.
export default class extends Controller {
  connect() {
    this.onDocumentClick = this.#handleClick.bind(this)
    document.addEventListener("click", this.onDocumentClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
  }

  #handleClick(event) {
    if (!this.element.classList.contains("show")) return
    if (this.element.contains(event.target)) return
    if (this.#toggle()?.contains(event.target)) return

    // getInstance, never getOrCreateInstance: an open panel always has an
    // instance (the data-api created it on the click that opened it), and
    // creating one here would attach a Collapse to the element on every stray
    // click in the document.
    Collapse.getInstance(this.element)?.hide()
  }

  // Found by what points AT this panel rather than by rebuilding the chip's id
  // convention here — the toggle lives in a different partial, and a naming
  // change there would otherwise close the panel out from under its own button.
  #toggle() {
    return document.querySelector(`[data-bs-target="#${this.element.id}"]`)
  }
}
